import { render, staticRenderFns } from "./discussion_counter.vue?vue&type=template&id=78a5b6e9&"
import script from "./discussion_counter.vue?vue&type=script&lang=js&"
export * from "./discussion_counter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "discussion_counter.vue"
export default component.exports